import * as api from '@/services';

export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {
    async getUserInfo({ commit }) {
      const userInfo = await api.login.getUserInfo();
      let salespersonInfo = {
        salespersonName: ''
      }
      try {
        salespersonInfo = await api.login.querySalespersonInfo(); // 查询销售人员信息
      } catch (e) {
        console.error(e)
      } finally {
        commit('SET_USER_INFO', {
          ...userInfo,
          employeeInfoVO: salespersonInfo
        })
      }
    }
  }
};
